const READINESS_COMPLETED_KEY = 'haiy_readiness_completed';
const READINESS_PROFILE_KEY = 'haiy_readiness_profile_v1';

const safeStorage = (persistent = false) => {
  if (typeof window === 'undefined') return null;
  try {
    return persistent ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
};

const parseJson = (raw, fallback = null) => {
  if (!raw) return fallback;
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

export const getReadinessStorage = (isAuthenticated = false) => safeStorage(Boolean(isAuthenticated));

export const loadReadinessProfile = (isAuthenticated = false) => {
  const storage = getReadinessStorage(isAuthenticated);
  return parseJson(storage?.getItem(READINESS_PROFILE_KEY), null);
};

export const isReadinessCompletedStored = (isAuthenticated = false) => {
  const storage = getReadinessStorage(isAuthenticated);
  return storage?.getItem(READINESS_COMPLETED_KEY) === '1';
};

export const saveReadinessProfile = (payload, isAuthenticated = false) => {
  const storage = getReadinessStorage(isAuthenticated);
  if (!storage) return;
  storage.setItem(READINESS_PROFILE_KEY, JSON.stringify(payload));
  storage.setItem(READINESS_COMPLETED_KEY, payload?.completed ? '1' : '0');
  window.dispatchEvent(new CustomEvent('wowrolla:readiness-profile-updated', { detail: payload }));
};

export const clearReadinessProfile = (isAuthenticated = false) => {
  const storage = getReadinessStorage(isAuthenticated);
  storage?.removeItem(READINESS_PROFILE_KEY);
  storage?.removeItem(READINESS_COMPLETED_KEY);
};

export const migrateGuestReadinessToAuthenticated = () => {
  const guestPayload = loadReadinessProfile(false);
  if (!guestPayload) return null;
  saveReadinessProfile(guestPayload, true);
  clearReadinessProfile(false);
  return guestPayload;
};

export { READINESS_COMPLETED_KEY, READINESS_PROFILE_KEY };

